<script lang="ts" setup>
  defineProps<{ label: string }>();
  defineEmits<{ click: [button: HTMLElement] }>();
</script>

<template>
  <button class="header-button" type="button" @click="$emit('click', $event.currentTarget as HTMLElement)">
    <svg
      fill="none"
      height="30"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2.5"
      viewBox="0 0 24 24"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <slot />
    </svg>
    <span class="label">{{ label }}</span>
  </button>
</template>

<style scoped>
  .header-button {
    align-items: center;
    background: color-mix(in srgb, var(--color-primary), transparent 90%);
    border: none;
    border-radius: var(--radius-control);
    color: var(--color-primary);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font: inherit;
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-strong);
    gap: 0.1rem;
    justify-content: center;
    line-height: 1;
    min-height: var(--size-touch-target);
    min-width: var(--size-touch-target);
    padding: 0.375rem 0.5rem;
    transition: transform 0.15s;

    &:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }

    &:active {
      transform: scale(0.92);
    }
  }

  .header-button svg {
    display: block;
  }

  .label {
    white-space: nowrap;
  }
</style>
